export default __webpack_public_path__ + "static/media/bg-tile-4.0ea92a0b.webp";